<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

        <section class="section about p-0">
          <div class="container" style="margin-top:80px">
            <div class="row">
              <div class="col-lg-6 align-self-center">
                <div class="content text-center text-lg-left">
                  <h2>Plataforma de Administração Tributária Digital</h2>

                  <p>
                    A Secretaria Especial da Receita Federal do Brasil (RFB) lançou no último dia 30 de junho, 
                    a Plataforma de Administração Tributária Digital.
                    <br><br>
                    De acordo com a Portaria ASCIF Nº 5, publicada no Diário Oficial da União no dia 07/07/2022, 
                    já está disponível por meio de processo digital aberto no Centro Virtual de Atendimento (e-CAC), 
                    o serviço Aderir ao Convênio da NFS-e. 
                    <br>
                    O serviço está localizado na área de concentração temática (ACT) Celebração de Acordos Nacionais, no Portal e-CAC.
                    <br><br>
                    O convênio, assinado pela Associação Brasileira das Secretarias de Finanças das Capitais (Abrasf), 
                    é o instrumento necessário para o funcionamento da Plataforma, 
                    que oferece uma cesta de produtos tecnológicos de administração tributária, beneficiando municípios e empresas. 
                    <br><br>
                    O projeto é coordenado pela Receita Federal do Brasil em parceria com a Associação Brasileira das Secretarias de Finanças das Capitais (Abrasf), 
                    a Confederação Nacional de Municípios (CNM), a Frente Nacional de Prefeitos (FNP), 
                    o Sebrae, o Serpro, mais de 60 entidades representativas dos prestadores de serviço e 114 empresas conveniadas. 
                    <br><br>
                    Cada administração tributária municipal que aderir ao convênio poderá escolher, 
                    entre as soluções disponíveis na Plataforma, aqueles que deseja implementar em sua cidade.
                  </p>
                </div>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="about-slider">
                  <div class="item">
                    <img class="w-100" 
                          src="../../assets/images/ibcgp/publications/maxplataformaadmintribdigital.jpeg" 
                          alt="Imagem de valores do instituto"
                          style="border-radius: 15px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="section cta-hire bg-gary">
        <contact/>
      </section>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import Contact from '../contact/ShortcutContact.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Artigos e Publicações";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'contact'                 : Contact,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
    beforeMount() {
      this.navPublications = true;
    }
  }
</script>